import React, { Component, useState } from 'react'
import updateField from '../../actionCreators/updateField'
import updateSheet from '../../actionCreators/updateSheet'
import { connect } from 'react-redux'
import InlineEditor from '../InlineEditor'
import LiveTooltip from 'live/components/ui/tooltip'
import { SpreadsheetHeader } from '../main/options/model/types'

interface IProps {
    sheet: number | string
    type: 'string' | 'number' | 'date'
    updateField: any
    updateSheet: any
    updatedSuccessfully: boolean
    onlyView?: boolean
    update?: boolean
    cell: SpreadsheetHeader
    updateCell: (cell: SpreadsheetHeader) => void
}

export function HeaderCell({
    sheet,
    updateSheet,
    updatedSuccessfully,
    onlyView,
    updateCell,
    cell
}: IProps): JSX.Element {
    const { alias, isDisabled, isKey, isNotNull, name, type } = cell

    const updateAlias = value => {
        updateCell({
            ...cell,
            alias: value
        })
    }

    const updateNotNull = () => {
        updateCell({
            ...cell,
            isNotNull: !isNotNull
        })
    }

    const toggleKey = () => {
        updateCell({
            ...cell,
            isKey: !isKey
        })
    }

    const toggleDisabled = () => {
        updateCell({
            ...cell,
            isDisabled: !isDisabled
        })
    }

    return (
        <th
            className="column-name"
            style={{
                backgroundColor: onlyView ? 'var(--gray-100)' : undefined
            }}
        >
            <div className="header-wrapper" style={{ display: 'flex', flexDirection: 'row' }}>
                <InlineEditor value={alias} onlyView={onlyView} onChange={updateAlias} />
                <LiveTooltip position="top" content={`Single Key ${isKey ? 'Enabled' : 'Disabled'}`}>
                    <button onClick={!onlyView ? toggleKey : null}>
                        <i className={`fa fa-key ${isKey ? 'clicked' : ''}`} aria-hidden="true" />
                    </button>
                </LiveTooltip>
                <LiveTooltip
                    position="top"
                    content={`(${isNotNull ? 'Not' : 'Yes'} NULL) Prevents inserting NULL values to the column.`}
                >
                    <button
                        onClick={!onlyView ? updateNotNull : null}
                        style={{ padding: '0px 5px 0px 0px', color: isNotNull ? '#01C292' : 'var(--gray-600)' }}
                    >
                        <i className={`fa fa-check-double`} aria-hidden="true" />
                    </button>
                </LiveTooltip>
                <LiveTooltip position="top" content={`${isDisabled ? 'Inactive' : 'Active'} Column`}>
                    <button onClick={!onlyView ? toggleDisabled : null}>
                        <i className={`fa fa-ban ${isDisabled ? 'clicked-red' : ''}`} aria-hidden="true" />
                    </button>
                </LiveTooltip>
            </div>
        </th>
    )
}

export default connect(null, {
    updateField,
    updateSheet
})(HeaderCell)
